import * as React from 'react';
import { Link } from 'gatsby';
// import { StaticImage } from 'gatsby-plugin-image';
import { Main } from '../styles/TabsidebarBlock';

const TabSidebarBlock = () => (
  <Main>
    <Link to="/">
      <span>General SEO settings</span>
    </Link>
    <Link to="/branding/">
      <span>Branding</span>
    </Link>
    <Link to="/typography/">
      <span>Typography</span>
    </Link>
    <Link to="/analytics/">
      <span>Analytics</span>
    </Link>
    <Link to="/social-media/">
      <span>Social Media</span>
    </Link>
    <Link to="/advertising/">
      <span>Advertising Setup</span>
    </Link>
  </Main>
);

export default TabSidebarBlock;
